import React, { Component } from 'react';
import { Progress } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import styled from 'styled-components';

const AchievementContainer = styled.div`
  margin: 10px 20px;
  min-height:175px;
  display: flex;
  flex-direction: column;
`;

const AchievementDiv = styled.div`
  flex: 1;
  text-align:center;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${props => (props.achieved ? '#EBF8EA' : '#fff')};
  border: 0.5px solid ${props => (props.achieved ? '#bfd9bd' : '#babcbe')};
  span{
    display:block;
  }
  .achievement-icon{
    line-height:40px;
    font-size:40px;
    padding-bottom:10px;
    position:relative;
  }
  .name {
    font-size:16px;
    margin-bottom:5px;
  }
  .meta{
    color: #5d5d5d
  }
  .description {
    font-size:14px;
    color:rgb(170,170,170);
    margin-bottom:10px;
  }
  &.not-won{
    span {
      display:block;
      margin-left:auto;
      margin-right:auto;
    }
    .icon {
      width:40px;
      height:40px;
      border-radius:50%;
      background:rgb(220,220,220);
      margin-bottom:20px;
      box-shadow: 0px 4px 4px rgb(200,200,200);
    }
    .name {
      width:40%;
      height:15px;
      background:rgb(210,210,210);
      border-radius:3px;
      box-shadow: 0px 2px 2px rgb(200,200,200);
      margin-bottom: 10px;
    }
  }
`;

const ProgressBar = styled(Progress)`
  margin: 10px!Important;
  .label{
    color: #e2e7f3 !important
  }
`;

class AchievementComponent extends Component {
  render() {
    const { achievement, showDate, showAllInfo } = this.props;
    const {
      name, icon, description, achievedAt, exp, progress = 0, count = 0, help,
    } = achievement;
    const achieved = (achievement.achieved || showAllInfo);

    return (
      <AchievementContainer className="achievement-component">
        <AchievementDiv achieved={achieved} className={!achieved ? 'not-won' : ''}>
          {achieved
            ? <span role="img" aria-label={name} className="achievement-icon" dangerouslySetInnerHTML={{ __html: icon }} />
            : <span className="icon" />
          }
          <span className="name">{achieved && <b>{name}</b>}</span>
          {description ? <span className="description">{achieved ? description : help}</span> : null}
          {count
            ? (
              <div style={{ width: '100%' }}>
                <ProgressBar
                  className="progress-bar-achievement"
                  progress="ratio"
                  success={achieved}
                  value={progress}
                  total={count}
                />
              </div>
            )

            : null}
          {achieved && (
          <span className="meta">
            EXP:
            {exp}
          </span>
          )}
        </AchievementDiv>
        {achievedAt && (
        <span className="meta" style={{ color: '#babcbe' }}>
          Achieved
          {showDate ? moment(achievedAt).format('DD/MM/YY') : moment(achievedAt).fromNow()}
        </span>
        )}
      </AchievementContainer>
    );
  }
}

export default withTranslation()(AchievementComponent);
